<template>
  <div
    class="modal fade"
    id="supportModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="supportModalTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="supportModalTitle">Support</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Wenn Sie Fragen haben oder einen Fachmann für die Windsogsicherung benötigen, können Sie uns gerne kontaktieren!</p>
          <p>
            <a href="tel:+492852711116">Telefon: + 49 – 28 52 – 71 11 16</a>
            <br />Telefax: + 49 – 28 52 – 71 11 26
            <a href="mailto:info@luetfrink.de">
              <br />E-Mail: info@luetfrink.de
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "SupportModal",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

